import { useMutation } from '@tanstack/react-query';
import { tokenInspectorApi } from '../api/tokenInspectorApi';
import type { DecodedTokenView } from '../types/tokenInspector.types';

/**
 * Mutation: POST /api/eraf/dev/token-inspector/decode
 * Decodes an arbitrary JWT string and returns signature/expiry/blacklist status.
 * A 200 is always returned regardless of signature validity (signatureValid flag).
 */
export function useDecodeToken() {
  return useMutation<DecodedTokenView, { code: string; message: string }, string>({
    mutationFn: (token: string) => tokenInspectorApi.decode({ token }),
  });
}
